import React, { useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

const FIELD_GR = {
  start_time: 'ώρα έναρξης', end_time: 'ώρα λήξης', duration_seconds: 'διάρκεια', artist: 'καλλιτέχνης',
  title: 'τίτλος', isrc: 'ISRC', data_mode: 'πηγή', recording_mode: 'τρόπος καταγραφής',
};
const fmt = (iso) => (iso ? new Date(iso.endsWith('Z') || iso.includes('+') ? iso : `${iso}Z`).toLocaleTimeString('el-GR', { hour12: false }) : '—');
const diffText = (d) => (d.delta_seconds !== undefined
  ? `${FIELD_GR[d.field] || d.field} ${d.delta_seconds > 0 ? '+' : ''}${d.delta_seconds}΄΄`
  : `${FIELD_GR[d.field] || d.field}: «${d.a ?? '—'}» ↔ «${d.b ?? '—'}»`);

const List = ({ rows, testId, showDiff }) => (
  <div className="max-h-40 overflow-y-auto space-y-0.5 mt-1" data-testid={testId}>
    {rows.map((r, i) => (
      <div key={i} className="text-gray-700 dark:text-gray-300">
        {fmt(r.start_time)} · <b>{r.station}</b> · {r.artist} – {r.title}
        {r.servers && <span className="text-gray-500"> ({r.servers.join(' / ')})</span>}
        {showDiff && r.differences?.length > 0 && <span className="text-amber-700 dark:text-amber-400"> — {r.differences.map(diffText).join(' · ')}</span>}
      </div>
    ))}
  </div>
);

const Group = ({ label, count, rows, testId, showDiff, color }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      <button type="button" className={`text-left hover:underline ${color}`} onClick={() => setOpen(!open)} data-testid={`${testId}-toggle`} disabled={!count}>
        {label}: <b>{count}</b> {count ? (open ? '▲' : '▼') : ''}
      </button>
      {open && <List rows={rows} testId={testId} showDiff={showDiff} />}
    </div>
  );
};

export const CommonSongsSection = ({ token, onLoaded }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API}/api/diagnostic/fleet-servers/common-songs?minutes=60`, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const j = await res.json();
      setData(j);
      onLoaded?.(j);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  const s = data?.summary;
  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-md p-2.5 text-[11px] bg-white dark:bg-gray-900 mt-2" data-testid="fleet-common-songs">
      <div className="flex items-center gap-2">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">Κοινά τραγούδια · τελευταία ώρα</span>
        <button type="button" onClick={load} disabled={loading} className="ml-auto text-blue-600 dark:text-blue-400 hover:underline" data-testid="fleet-common-songs-load-btn">
          {loading ? 'Σύγκριση…' : (data ? 'Ανανέωση' : 'Σύγκριση')}
        </button>
      </div>
      {error && <div className="text-red-600" data-testid="fleet-common-songs-error">Σφάλμα: {error}</div>}
      {s && (
        <div className="space-y-1 mt-1.5" data-testid="fleet-common-songs-summary">
          <div className="text-gray-500">Εξετάστηκαν {data.records_examined} εγγραφές</div>
          <Group label="Ίδια και στους δύο" count={s.identical} rows={data.identical} testId="fleet-common-identical" color="text-green-700 dark:text-green-400" />
          <Group label="Ίδιο τραγούδι, διαφορετικά στοιχεία" count={s.same_song_different_details} rows={data.same_song_different_details} testId="fleet-common-different" showDiff color="text-amber-700 dark:text-amber-400" />
          <Group label="Διπλή εγγραφή (δύο εγγραφές για το ίδιο τραγούδι)" count={s.duplicate_records} rows={data.duplicate_records} testId="fleet-common-duplicates" showDiff color="text-red-700 dark:text-red-400" />
          {Object.entries(s.only_by_server || {}).map(([srv, cnt]) => (
            <Group key={srv} label={`Μόνο ο ${srv}`} count={cnt} rows={data.only_by_server[srv]} testId={`fleet-common-only-${srv.toLowerCase()}`} color="text-gray-700 dark:text-gray-300" />
          ))}
          {s.unattributed_old_records > 0 && <div className="text-gray-500">Παλιές εγγραφές χωρίς ένδειξη server: {s.unattributed_old_records}</div>}
          {Object.keys(s.difference_fields || {}).length > 0 && (
            <div className="text-gray-500" data-testid="fleet-common-diff-fields">
              Πού διαφέρουν: {Object.entries(s.difference_fields).map(([k, v]) => `${FIELD_GR[k] || k} ${v}`).join(' · ')}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
